const getRandomItem = function (itemArray) {
    if (itemArray && itemArray.length) {
        return itemArray[Math.floor(Math.random() * Math.floor(itemArray.length))];
    }
    return null;
};
export default getRandomItem;
